export const getters = {
  getAppId(state) {
    return state.appName
  },
  appTitle(state) {
    return state.appName
  },
  getUser(state) {
    if (state.user != null) {
      return state.user
    }
    state.user = JSON.parse(localStorage.getItem('UserInfo'))
    return state.user
  },
  getError(state) {
    return state.error
  },
  getLoading(state) {
    return state.loading
  },
  getAccessToken(state) {
    if (state.access_token != null) {
      return state.access_token
    }
    state.access_token = localStorage.getItem('AccessToken')
    return state.access_token
  },
  getLineId(state) {
    return state.line_id
  },
  isAuth(state) {
    return state.isAuth
  },
  getlogoUrl(state) {
    return state.logoUrl
  },
  getTheme(state) {
    return state.theme
  },
  getAlertImage(state) {
    return state.alertImage
  },
  getAlertMessage(state) {
    return state.alertMessage
  },
  getPhotoCashback(state) {
    return state.img_cashback
  },
  getPhotoAffiliate(state) {
    return state.img_affiliate
  },
  getGameList(state) {
    if (state.gameList != '') {
      console.log(state.gameList)
      return JSON.parse(state.gameList)
    } else {
      state.gameList = localStorage.getItem('gameList')
      return JSON.parse(state.gameList)
    }
  },
  getPrefix(state) {
    if (state.prefix != '') {
      return JSON.parse(state.prefix)
    } else {
      state.prefix = localStorage.getItem('Prefix')
      return JSON.parse(state.prefix)
    }
  },
  getPromotion(state) {
    return state.promotion
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/getters.js